import { useState } from "react";

const fontLink = document.createElement("link");
fontLink.rel = "stylesheet";
fontLink.href = "https://fonts.googleapis.com/css2?family=Barlow+Condensed:wght@600;700;800&family=DM+Sans:wght@300;400;500;600;700&display=swap";
document.head.appendChild(fontLink);

const C = {
  navy: "#0D1F3C", navyLight: "#1A3460", gray: "#D9DDDC", grayDark: "#C8CCCA",
  grayDarker: "#B0B4B3", steel: "#4A7FA5", white: "#FFFFFF",
};

const css = `
  *,*::before,*::after{box-sizing:border-box;margin:0;padding:0}
  html,body{min-height:100%;background:${C.gray};font-family:'DM Sans',sans-serif;color:${C.navy}}
  .iyc-root{min-height:100vh;display:flex;flex-direction:column;align-items:center;justify-content:flex-start;padding:40px 20px 80px;background:${C.gray}}
  .iyc-body{display:flex;align-items:flex-start;gap:20px;width:100%;max-width:820px}
  .step-sidebar{flex-shrink:0;width:44px;display:flex;flex-direction:column;align-items:center;gap:4px;padding-top:4px}
  .step-pip{width:28px;height:28px;border-radius:50%;display:flex;align-items:center;justify-content:center;font-family:'DM Sans',sans-serif;font-size:10px;font-weight:700;transition:all 0.15s;border:2px solid transparent;flex-shrink:0;line-height:1}
  .step-pip.completed{background:${C.navy};color:white;cursor:pointer;border-color:${C.navy}}
  .step-pip.completed:hover{background:${C.navyLight};border-color:${C.navyLight}}
  .step-pip.current{background:white;color:${C.navy};border-color:${C.navy};cursor:default}
  .step-pip.locked{background:transparent;color:${C.grayDarker};border-color:${C.grayDark};cursor:default}
  .step-pip-connector{width:2px;height:6px;background:${C.grayDark};border-radius:1px}
  .step-pip-connector.done{background:${C.navy}}
  .iyc-logo{display:flex;flex-direction:column;align-items:center;margin-bottom:36px}
  .logo-even{font-family:'Barlow Condensed',sans-serif;font-weight:800;font-size:28px;letter-spacing:0.04em;color:${C.navy};line-height:1;text-transform:uppercase}
  .logo-ground{font-family:'Barlow Condensed',sans-serif;font-weight:800;font-size:28px;letter-spacing:0.04em;color:rgba(13,31,60,0.55);line-height:1;text-transform:uppercase}
  .logo-sub{font-size:10px;font-weight:600;letter-spacing:0.22em;text-transform:uppercase;color:${C.grayDarker};margin-top:8px}
  .iyc-card{background:${C.white};border-radius:6px;width:100%;max-width:600px;overflow:hidden;box-shadow:0 8px 40px rgba(13,31,60,0.10)}
  .progress-bar-wrap{height:3px;background:${C.grayDark};width:100%}
  .progress-bar-fill{height:100%;background:${C.navy};transition:width 0.4s ease}
  .step-header{padding:28px 36px 0}
  .step-count{font-size:10px;font-weight:700;letter-spacing:0.22em;text-transform:uppercase;color:${C.grayDarker};margin-bottom:8px}
  .step-title{font-family:'Barlow Condensed',sans-serif;font-weight:800;font-size:26px;text-transform:uppercase;letter-spacing:0.03em;color:${C.navy};line-height:1.1;margin-bottom:4px}
  .step-subtitle{font-size:13px;color:${C.grayDarker};font-weight:400;line-height:1.6;margin-bottom:0}
  .step-body{padding:24px 36px 32px}
  .field-group{margin-bottom:18px}
  .field-label{font-size:10px;font-weight:700;letter-spacing:0.18em;text-transform:uppercase;color:${C.grayDarker};margin-bottom:6px;display:block}
  .field-input,.field-select,.field-textarea{width:100%;font-family:'DM Sans',sans-serif;font-size:14px;border:1.5px solid ${C.grayDark};border-radius:3px;padding:10px 12px;color:${C.navy};background:${C.white};outline:none;transition:border 0.15s;-webkit-appearance:none}
  .field-input:focus,.field-select:focus,.field-textarea:focus{border-color:${C.steel}}
  .field-textarea{resize:vertical;min-height:90px;line-height:1.6}
  .field-row{display:grid;grid-template-columns:1fr 1fr;gap:14px}
  .field-row.three{grid-template-columns:1fr 1fr 1fr}
  .field-error{font-size:11px;color:#8B2020;margin-top:4px;font-weight:600}
  .choice-grid{display:flex;flex-direction:column;gap:10px}
  .choice-card{border:1.5px solid ${C.grayDark};border-radius:4px;padding:13px 16px;cursor:pointer;transition:all 0.15s;display:flex;align-items:flex-start;gap:12px;background:${C.white}}
  .choice-card:hover{border-color:${C.steel};background:#f5f8fb}
  .choice-card.selected{border-color:${C.navy};background:#f0f3f8}
  .choice-radio{width:16px;height:16px;border-radius:50%;border:2px solid ${C.grayDark};flex-shrink:0;margin-top:2px;transition:all 0.15s;display:flex;align-items:center;justify-content:center}
  .choice-card.selected .choice-radio{border-color:${C.navy};background:${C.navy}}
  .choice-radio-dot{width:6px;height:6px;border-radius:50%;background:white}
  .choice-label{font-size:13px;font-weight:600;color:${C.navy};line-height:1.3}
  .choice-desc{font-size:11px;color:${C.grayDarker};margin-top:2px;line-height:1.5;font-weight:400}
  .upload-zone{border:2px dashed ${C.grayDark};border-radius:4px;padding:24px;text-align:center;cursor:pointer;transition:all 0.15s;background:#fafafa}
  .upload-zone:hover{border-color:${C.steel};background:#f0f5fa}
  .upload-zone-text{font-size:12px;font-weight:600;color:${C.grayDarker}}
  .upload-zone-sub{font-size:11px;color:${C.grayDarker};margin-top:3px}
  .upload-files{display:flex;flex-wrap:wrap;gap:8px;margin-top:10px}
  .upload-file-tag{display:flex;align-items:center;gap:6px;padding:4px 10px;background:${C.gray};border-radius:3px;font-size:11px;font-weight:600;color:${C.navy};border:1px solid ${C.grayDark}}
  .upload-remove{cursor:pointer;color:#8B2020;font-weight:900;font-size:13px;line-height:1}
  .trade-reveal{background:#f7f8f9;border:1px solid ${C.grayDark};border-radius:4px;padding:18px 20px;margin-top:12px}
  .trade-reveal-title{font-size:10px;font-weight:700;letter-spacing:0.18em;text-transform:uppercase;color:${C.grayDarker};margin-bottom:14px}
  .checkbox-row{display:flex;align-items:center;gap:10px;cursor:pointer}
  .checkbox-input{width:16px;height:16px;cursor:pointer;flex-shrink:0}
  .checkbox-label{font-size:13px;font-weight:600;color:${C.navy}}
  .step-nav{display:flex;justify-content:space-between;align-items:center;padding:20px 36px 28px;border-top:1px solid ${C.gray}}
  .btn{display:inline-flex;align-items:center;gap:6px;padding:11px 24px;border-radius:3px;font-family:'DM Sans',sans-serif;font-size:11px;font-weight:700;letter-spacing:0.12em;text-transform:uppercase;border:none;cursor:pointer;transition:all 0.15s}
  .btn-primary{background:${C.navy};color:#fff}
  .btn-primary:hover{background:${C.navyLight}}
  .btn-primary:disabled{background:${C.grayDark};cursor:not-allowed}
  .btn-ghost{background:transparent;color:${C.navy};border:1.5px solid ${C.grayDark}}
  .btn-ghost:hover{background:${C.gray}}
  .disclosure{background:#f7f8f9;border:1px solid ${C.grayDark};border-radius:3px;padding:16px;font-size:11px;color:rgba(13,31,60,0.55);line-height:1.7;margin-bottom:18px;display:flex;gap:12px;align-items:flex-start}
  .complete-screen{padding:52px 36px;text-align:center}
  .complete-icon{font-size:40px;margin-bottom:20px}
  .complete-title{font-family:'Barlow Condensed',sans-serif;font-weight:800;font-size:32px;text-transform:uppercase;letter-spacing:0.03em;color:${C.navy};margin-bottom:12px}
  .complete-text{font-size:14px;color:${C.grayDarker};line-height:1.75;max-width:420px;margin:0 auto}
  @media(max-width:600px){
    .iyc-root{padding:24px 12px 60px}
    .step-sidebar{display:none}
    .iyc-body{flex-direction:column;align-items:center}
    .step-header{padding:22px 22px 0}
    .step-body{padding:18px 22px 24px}
    .step-nav{padding:16px 22px 22px}
    .field-row,.field-row.three{grid-template-columns:1fr}
  }
`;
const styleEl = document.createElement("style");
styleEl.textContent = css;
document.head.appendChild(styleEl);

function FG({ label, error, children }) {
  return (
    <div className="field-group">
      {label && <label className="field-label">{label}</label>}
      {children}
      {error && <div className="field-error">{error}</div>}
    </div>
  );
}

function ChoiceCard({ value, selected, onSelect, label, desc }) {
  return (
    <div className={`choice-card ${selected ? "selected" : ""}`} onClick={() => onSelect(value)}>
      <div className="choice-radio">{selected && <div className="choice-radio-dot" />}</div>
      <div>
        <div className="choice-label">{label}</div>
        {desc && <div className="choice-desc">{desc}</div>}
      </div>
    </div>
  );
}

const STEPS = [
  { id: "contact", title: "Let's Get Started",   subtitle: "Tell us who you are so we know how to reach you." },
  { id: "vehicle", title: "The Vehicle",          subtitle: "Tell us about the vehicle you're negotiating on and the dealer you're working with." },
  { id: "status",  title: "Where Things Stand",   subtitle: "Tell us where you are in the negotiation." },
  { id: "deal",    title: "The Deal",             subtitle: "Share what you have and tell us what a good outcome looks like for you." },
  { id: "confirm", title: "One Last Thing",       subtitle: "Review and confirm before we get started." },
];

export default function IYCApp() {
  const [step, setStep] = useState(0);
  const [errors, setErrors] = useState({});
  const [submitted, setSubmitted] = useState(false);
  const [submitting, setSubmitting] = useState(false);
  const [submitError, setSubmitError] = useState(null);
  const [uploadedFiles, setUploadedFiles] = useState([]);

  const [f, setF] = useState({
    firstName: "", lastName: "", phone: "", email: "", zip: "",
    vehicleYear: "", vehicleMake: "", vehicleModel: "", vehicleTrim: "",
    dealerName: "", dealerLocation: "",
    hasTrade: false,
    tradeYear: "", tradeMake: "", tradeModel: "", tradeMileage: "", tradeOffer: "",
    processStage: "",
    dealerInfo: "",
    goodOutcome: "",
    questionsBeforeStart: "",
    contactMethod: "",
    disclosureAgreed: false,
  });

  const set = (k, v) => setF(p => ({ ...p, [k]: v }));
  const clearErr = (k) => setErrors(p => { const n = { ...p }; delete n[k]; return n; });

  const validate = () => {
    const errs = {};
    const id = STEPS[step].id;
    if (id === "contact") {
      if (!f.firstName.trim()) errs.firstName = "Required";
      if (!f.lastName.trim()) errs.lastName = "Required";
      if (!f.phone.trim()) errs.phone = "Required";
      if (!f.email.trim()) errs.email = "Required";
      if (!f.zip.trim()) errs.zip = "Required";
    }
    if (id === "vehicle") {
      if (!f.vehicleYear.trim()) errs.vehicleYear = "Required";
      if (!f.vehicleMake.trim()) errs.vehicleMake = "Required";
      if (!f.vehicleModel.trim()) errs.vehicleModel = "Required";
      if (!f.dealerName.trim()) errs.dealerName = "Required";
    }
    if (id === "status") {
      if (!f.processStage) errs.processStage = "Please select one";
    }
    if (id === "deal") {
      if (!f.dealerInfo.trim()) errs.dealerInfo = "Required";
      if (!f.goodOutcome.trim()) errs.goodOutcome = "Required";
    }
    if (id === "confirm") {
      if (!f.contactMethod) errs.contactMethod = "Please select one";
      if (!f.disclosureAgreed) errs.disclosureAgreed = "Please confirm before submitting";
    }
    setErrors(errs);
    return Object.keys(errs).length === 0;
  };

  const handleFiles = (files) => {
    const newFiles = Array.from(files).map(file => ({ name: file.name, type: file.type }));
    setUploadedFiles(prev => [...prev, ...newFiles]);
  };

  const removeFile = (idx) => setUploadedFiles(prev => prev.filter((_, i) => i !== idx));

  const submit = async () => {
    setSubmitting(true);
    setSubmitError(null);
    const lines = [
      `IN YOUR CORNER INTAKE`,
      `=====================`,
      ``,
      `CONTACT`,
      `-------`,
      `Name: ${f.firstName} ${f.lastName}`,
      `Phone: ${f.phone}`,
      `Email: ${f.email}`,
      `Zip: ${f.zip}`,
      `Preferred Contact: ${f.contactMethod}`,
      ``,
      `VEHICLE`,
      `-------`,
      `Vehicle: ${f.vehicleYear} ${f.vehicleMake} ${f.vehicleModel}${f.vehicleTrim ? " " + f.vehicleTrim : ""}`,
      `Dealer: ${f.dealerName}${f.dealerLocation ? ", " + f.dealerLocation : ""}`,
      ``,
      `TRADE-IN`,
      `--------`,
      f.hasTrade ? [
        `Has Trade: Yes`,
        `Trade Vehicle: ${f.tradeYear} ${f.tradeMake} ${f.tradeModel}`,
        f.tradeMileage ? `Mileage: ${f.tradeMileage}` : null,
        f.tradeOffer ? `Existing Offer: ${f.tradeOffer}` : null,
      ].filter(Boolean).join("\n") : `Has Trade: No`,
      ``,
      `PROCESS STAGE`,
      `-------------`,
      `Stage: ${f.processStage}`,
      ``,
      `THE DEAL`,
      `--------`,
      `What dealer sent/said:\n${f.dealerInfo}`,
      uploadedFiles.length > 0 ? `Uploaded Files: ${uploadedFiles.map(fi => fi.name).join(", ")}` : null,
      ``,
      `Good outcome:\n${f.goodOutcome}`,
      f.questionsBeforeStart ? `\nQuestions before we start:\n${f.questionsBeforeStart}` : null,
    ].filter(l => l !== null).join("\n");

    try {
      const res = await fetch("https://formspree.io/f/xjgaongz", {
        method: "POST",
        headers: { "Content-Type": "application/json", "Accept": "application/json" },
        body: JSON.stringify({
          _subject: `Even Ground — In Your Corner — ${f.firstName} ${f.lastName} — ${f.vehicleYear} ${f.vehicleMake} ${f.vehicleModel}`,
          message: lines,
          email: f.email || "no-email@getevenground.com",
        }),
      });
      if (!res.ok) throw new Error("Submission failed");
      setSubmitted(true);
    } catch (e) {
      setSubmitError("Something went wrong. Please try again or email thomas@getevenground.com.");
    } finally {
      setSubmitting(false);
    }
  };

  const next = async () => {
    if (!validate()) return;
    if (step < STEPS.length - 1) {
      setStep(s => s + 1);
    } else {
      await submit();
    }
  };

  const back = () => { setErrors({}); setStep(s => s - 1); };

  const currentStep = STEPS[step];
  const progress = ((step + 1) / STEPS.length) * 100;

  if (submitted) {
    return (
      <div className="iyc-root">
        <div className="iyc-logo">
          <div className="logo-even">EVEN</div>
          <div className="logo-ground">GROUND</div>
          <div className="logo-sub">In Your Corner</div>
        </div>
        <div className="iyc-card" style={{ maxWidth: 600 }}>
          <div className="complete-screen">
            <div className="complete-icon">✓</div>
            <div className="complete-title">You're In.</div>
            <div className="complete-text">
              I have everything I need. I'll review your deal and get back to you within a few hours. Keep your phone nearby — we have work to do.
            </div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="iyc-root">
      <div className="iyc-logo">
        <div className="logo-even">EVEN</div>
        <div className="logo-ground">GROUND</div>
        <div className="logo-sub">In Your Corner — Intake</div>
      </div>
      <div className="iyc-body">
        <div className="step-sidebar">
          {STEPS.map((s, i) => (
            <div key={s.id} style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
              <div
                className={`step-pip ${i < step ? "completed" : i === step ? "current" : "locked"}`}
                onClick={() => i < step && setStep(i)}
              >{i + 1}</div>
              {i < STEPS.length - 1 && (
                <div className={`step-pip-connector ${i < step ? "done" : ""}`} />
              )}
            </div>
          ))}
        </div>

        <div className="iyc-card">
          <div className="progress-bar-wrap">
            <div className="progress-bar-fill" style={{ width: `${progress}%` }} />
          </div>
          <div className="step-header">
            <div className="step-count">Step {step + 1} of {STEPS.length}</div>
            <div className="step-title">{currentStep.title}</div>
            <div className="step-subtitle">{currentStep.subtitle}</div>
          </div>

          <div className="step-body">

            {currentStep.id === "contact" && (
              <>
                <div className="field-row">
                  <FG label="First Name" error={errors.firstName}>
                    <input className="field-input" value={f.firstName} onChange={e => { set("firstName", e.target.value); clearErr("firstName"); }} placeholder="First name" />
                  </FG>
                  <FG label="Last Name" error={errors.lastName}>
                    <input className="field-input" value={f.lastName} onChange={e => { set("lastName", e.target.value); clearErr("lastName"); }} placeholder="Last name" />
                  </FG>
                </div>
                <div className="field-row">
                  <FG label="Phone" error={errors.phone}>
                    <input className="field-input" type="tel" value={f.phone} onChange={e => { set("phone", e.target.value); clearErr("phone"); }} placeholder="(000) 000-0000" />
                  </FG>
                  <FG label="Email" error={errors.email}>
                    <input className="field-input" type="email" value={f.email} onChange={e => { set("email", e.target.value); clearErr("email"); }} placeholder="your@email.com" />
                  </FG>
                </div>
                <FG label="Zip Code" error={errors.zip}>
                  <input className="field-input" value={f.zip} onChange={e => { set("zip", e.target.value); clearErr("zip"); }} placeholder="Zip code" style={{ maxWidth: 180 }} />
                </FG>
              </>
            )}

            {currentStep.id === "vehicle" && (
              <>
                <div className="field-row three">
                  <FG label="Year" error={errors.vehicleYear}>
                    <input className="field-input" value={f.vehicleYear} onChange={e => { set("vehicleYear", e.target.value); clearErr("vehicleYear"); }} placeholder="e.g. 2025" />
                  </FG>
                  <FG label="Make" error={errors.vehicleMake}>
                    <input className="field-input" value={f.vehicleMake} onChange={e => { set("vehicleMake", e.target.value); clearErr("vehicleMake"); }} placeholder="e.g. Toyota" />
                  </FG>
                  <FG label="Model" error={errors.vehicleModel}>
                    <input className="field-input" value={f.vehicleModel} onChange={e => { set("vehicleModel", e.target.value); clearErr("vehicleModel"); }} placeholder="e.g. Tundra" />
                  </FG>
                </div>
                <FG label="Trim / Package">
                  <input className="field-input" value={f.vehicleTrim} onChange={e => set("vehicleTrim", e.target.value)} placeholder="e.g. TRD Pro (if known)" />
                </FG>
                <div className="field-row">
                  <FG label="Dealer Name" error={errors.dealerName}>
                    <input className="field-input" value={f.dealerName} onChange={e => { set("dealerName", e.target.value); clearErr("dealerName"); }} placeholder="e.g. Toyota of Dallas" />
                  </FG>
                  <FG label="Dealer City / State">
                    <input className="field-input" value={f.dealerLocation} onChange={e => set("dealerLocation", e.target.value)} placeholder="e.g. Dallas, TX" />
                  </FG>
                </div>
                <FG label="Trade-In">
                  <label className="checkbox-row">
                    <input className="checkbox-input" type="checkbox" checked={f.hasTrade} onChange={e => set("hasTrade", e.target.checked)} />
                    <span className="checkbox-label">I have a vehicle I'm trading in</span>
                  </label>
                  {f.hasTrade && (
                    <div className="trade-reveal">
                      <div className="trade-reveal-title">Trade-In Details</div>
                      <div className="field-row three">
                        <FG label="Year">
                          <input className="field-input" value={f.tradeYear} onChange={e => set("tradeYear", e.target.value)} placeholder="e.g. 2020" />
                        </FG>
                        <FG label="Make">
                          <input className="field-input" value={f.tradeMake} onChange={e => set("tradeMake", e.target.value)} placeholder="e.g. Honda" />
                        </FG>
                        <FG label="Model">
                          <input className="field-input" value={f.tradeModel} onChange={e => set("tradeModel", e.target.value)} placeholder="e.g. Civic" />
                        </FG>
                      </div>
                      <div className="field-row" style={{ marginTop: 14 }}>
                        <FG label="Rough Mileage">
                          <input className="field-input" value={f.tradeMileage} onChange={e => set("tradeMileage", e.target.value)} placeholder="e.g. 45,000" />
                        </FG>
                        <FG label="Existing Offer">
                          <input className="field-input" value={f.tradeOffer} onChange={e => set("tradeOffer", e.target.value)} placeholder="e.g. $12,000 from CarMax" />
                        </FG>
                      </div>
                    </div>
                  )}
                </FG>
              </>
            )}

            {currentStep.id === "status" && (
              <FG label="Where are you in the process" error={errors.processStage}>
                <div className="choice-grid">
                  {[
                    { value: "Just got a quote", label: "Just got a quote", desc: "Dealer sent numbers but we haven't gone back and forth yet" },
                    { value: "Going back and forth", label: "Going back and forth", desc: "We've been negotiating and I'm not sure if the deal is fair" },
                    { value: "Ready to sign soon", label: "Ready to sign soon", desc: "I have a deal on the table and want a final check before I commit" },
                  ].map(o => (
                    <ChoiceCard key={o.value} value={o.value} selected={f.processStage === o.value} onSelect={v => { set("processStage", v); clearErr("processStage"); }} label={o.label} desc={o.desc} />
                  ))}
                </div>
              </FG>
            )}

            {currentStep.id === "deal" && (
              <>
                <FG label="What has the dealer sent or said so far" error={errors.dealerInfo}>
                  <textarea className="field-textarea" value={f.dealerInfo} onChange={e => { set("dealerInfo", e.target.value); clearErr("dealerInfo"); }} placeholder="Paste any quotes, texts, or emails from the dealer. Out-the-door price, monthly payment, anything they've put in writing. The more detail the better." style={{ minHeight: 110 }} />
                </FG>
                <FG label="Upload a screenshot or deal sheet (optional)">
                  <div className="upload-zone" onClick={() => document.getElementById("iyc-upload").click()}>
                    <div className="upload-zone-text">Click to upload or drag and drop</div>
                    <div className="upload-zone-sub">Screenshot, PDF, or photo — up to 10MB</div>
                    <input id="iyc-upload" type="file" multiple accept="image/*,.pdf" style={{ display: "none" }} onChange={e => handleFiles(e.target.files)} />
                  </div>
                  {uploadedFiles.length > 0 && (
                    <div className="upload-files">
                      {uploadedFiles.map((file, idx) => (
                        <div key={idx} className="upload-file-tag">
                          {file.name}
                          <span className="upload-remove" onClick={() => removeFile(idx)}>×</span>
                        </div>
                      ))}
                    </div>
                  )}
                </FG>
                <FG label="What does a good outcome look like for you" error={errors.goodOutcome}>
                  <textarea className="field-textarea" value={f.goodOutcome} onChange={e => { set("goodOutcome", e.target.value); clearErr("goodOutcome"); }} placeholder="e.g. I want to make sure I'm not overpaying, I want the monthly payment under $500, I'm worried about the add-ons they keep pushing..." style={{ minHeight: 80 }} />
                </FG>
                <FG label="Any questions before we get started">
                  <textarea className="field-textarea" value={f.questionsBeforeStart} onChange={e => set("questionsBeforeStart", e.target.value)} placeholder="Anything you want to ask before I dig in. No question is too small." style={{ minHeight: 70 }} />
                </FG>
              </>
            )}

            {currentStep.id === "confirm" && (
              <>
                <div className="disclosure">
                  <input className="checkbox-input" type="checkbox" checked={f.disclosureAgreed} onChange={e => { set("disclosureAgreed", e.target.checked); clearErr("disclosureAgreed"); }} />
                  <span>I understand that Even Ground provides advisory and negotiation services only. I will contract directly with the dealership. Even Ground does not take possession of vehicles, handle my funds, or act as a vehicle broker. No specific savings amount or outcome is guaranteed. The final purchase decision is mine alone.</span>
                </div>
                {errors.disclosureAgreed && <div className="field-error" style={{ marginTop: -10, marginBottom: 14 }}>{errors.disclosureAgreed}</div>}
                <FG label="Preferred contact method" error={errors.contactMethod}>
                  <select className="field-select" value={f.contactMethod} onChange={e => { set("contactMethod", e.target.value); clearErr("contactMethod"); }}>
                    <option value="" disabled>Select one</option>
                    <option value="Email">Email</option>
                    <option value="Text">Text</option>
                    <option value="Either">Either</option>
                  </select>
                </FG>
                {submitError && <div className="field-error" style={{ marginBottom: 12 }}>{submitError}</div>}
              </>
            )}

          </div>

          <div className="step-nav">
            {step > 0 ? (
              <button className="btn btn-ghost" onClick={back}>&larr; Back</button>
            ) : <div />}
            <button className="btn btn-primary" onClick={next} disabled={submitting}>
              {step === STEPS.length - 1 ? (submitting ? "Submitting..." : "Submit") : "Continue \u2192"}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
